// Hook
export const useRandomId = () => {
    if ('randomUUID' in crypto) {
        return crypto.randomUUID()
    }
    const uint32 = window.crypto.getRandomValues(new Uint32Array(1))[0]
    return uint32.toString(16)
}
